import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { IHighlightDTO } from '../dto/highlight/highlight.dto';

@Injectable({
  providedIn: 'root',
})
export class HighlightService {
  private readonly httpClient: HttpClient = inject(HttpClient);

  public fetchHighlights(): Observable<IHighlightDTO[]> {
    return this.httpClient.get<IHighlightDTO[]>('/api/v1/private/highlights', {
      withCredentials: true,
    });
  }

  public fetchHighlightByPrimaryKey(
    primaryKey: string
  ): Observable<IHighlightDTO> {
    return this.httpClient.get<IHighlightDTO>(
      `/api/v1/private/highlights/${primaryKey}`,
      {
        withCredentials: true,
      }
    );
  }
}
